import { forwardRef } from 'react';
import { Stack, Box } from '@mui/joy';
import { useTheme, useMediaQuery } from '@mui/material';
import { useDragToScroll } from '@/hooks/useDragToScroll';

export const HorizontallyScrollable = forwardRef(function HorizontallyScrollable({ children, fadeColor = 'var(--joy-palette-background-body)' }, ref) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const dragToScroll = useDragToScroll();

  return (
    <Box sx={{
      position: 'relative',
      minWidth: 0,
      mx: { xs: -2, md: 0 },
      mr: { xs: -2, md: 0 },
      '&::after': !isMobile ? {
        content: '""',
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        width: 32,
        background: 'linear-gradient(to right, transparent, ' + fadeColor + ')',
        pointerEvents: 'none',
        display: { xs: 'block', md: 'none' },
      } : undefined,
    }}>
      <Stack
        ref={ref}
        {...dragToScroll}
        gap="6px" direction="row" alignItems="center" sx={{
        px: { xs: 2, md: 0 },
        overflowX: { xs: 'auto', md: 'visible' },
        flexWrap: { xs: 'nowrap', md: 'wrap' },
        scrollbarWidth: 'none',
        userSelect: 'none',
        cursor: { xs: 'grab', md: 'auto' },
        '&:active': { cursor: { xs: 'grabbing', md: 'auto' } },
        '&::-webkit-scrollbar': { display: 'none' },
      }}>
        {children}
      </Stack>
    </Box>
  );
});